import { createSlice } from '@reduxjs/toolkit';

import type { DocumentosState } from '@/types/processos/documentoStoreTypes';

import {
  atualizarDocumento,
  listarDocumentos,
  obterDownloadUrl,
  obterThumbnailUrl,
  removerDocumento,
  substituirDocumento,
  uploadDocumento,
} from './actions';

const initialState: DocumentosState = {
  itens: [],
  carregando: false,
  erro: null,
};

const documentosSlice = createSlice({
  name: 'documentos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listarDocumentos.pending, (state) => {
        state.carregando = true;
        state.erro = null;
      })
      .addCase(listarDocumentos.fulfilled, (state, action) => {
        state.carregando = false;
        state.itens = action.payload;
      })
      .addCase(listarDocumentos.rejected, (state, action) => {
        state.carregando = false;
        state.erro =
          (action.payload as string) || action.error.message || 'Erro ao listar documentos';
      })
      .addCase(uploadDocumento.fulfilled, (state, action) => {
        state.itens = [action.payload, ...state.itens];
      })
      .addCase(atualizarDocumento.fulfilled, (state, action) => {
        state.itens = state.itens.map((d) => (d.id === action.payload.id ? action.payload : d));
      })
      .addCase(removerDocumento.fulfilled, (state, action) => {
        state.itens = state.itens.filter((d) => d.id !== action.payload);
      })
      .addCase(substituirDocumento.fulfilled, (state) => {
        void state;
      })
      .addCase(obterDownloadUrl.fulfilled, (_state) => {
        void _state;
      })
      .addCase(obterThumbnailUrl.fulfilled, (_state) => {
        void _state;
      });
  },
});

export const documentosReducer = documentosSlice.reducer;
